import React from 'react'
import PropTypes from 'prop-types'
import styles from './FinancialAccountReview.module.scss'
import FinancialAccountSection from '../FinancialAccountSection/FinancialAccountSection'
import {
  getFinancialAccountData
} from 'utils/financialAccountTypes'

const FinancialAccountReview = (props) => {
  const {
    financialAccounts,
    accountsStatusOverview,
  } = props

  const mappedFinancialAccountSections = () => {
    const accounts = financialAccounts.map((financialAccount) => {
      const {
        id,
        attributes: {
          financialAccountType,
          subType
        }
      } = financialAccount

      const account = accountsStatusOverview.find(account => account.financialAccountId === id)
      const isComplete = account && account.complete

      const data = getFinancialAccountData(financialAccountType, 'RAW_TYPE', subType)
      return (
        <FinancialAccountSection
          key={id}
          financialAccountId={id}
          financialAccountDisplayName={data.DISPLAY}
          financialAccountType={data.ACCOUNT_TYPE_ROUTE}
          isComplete={isComplete} />
      )
    })
    return accounts
  }

  return (
    <div className={styles.FinancialAccountReview}>
      <h2>Your Accounts</h2>
      <div className={styles.FinancialAccountSectionContainer}>
        {mappedFinancialAccountSections()}
      </div>
    </div>
  )
}

FinancialAccountReview.propTypes = {
  financialAccounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  accountsStatusOverview: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default FinancialAccountReview



// WEBPACK FOOTER //
// ./src/components/Onboarding/ReviewAndSubmit/FinancialAccountReview/FinancialAccountReview.jsx